import axios from "axios";
import env from "app/utils/env";
import { getStore } from "app/configureStore";
import { COOKIES_AUTH_EXPIRES, COOKIES_OAUTH_EXPIRES } from "app/constants";
import Cookies from "js-cookie";
import {
	CLEAR_OAUTHORIZATION_CODE,
	OAUTH_SUCCESS,
	SAVE_OAUTHORIZATION_CODE,
} from "app/pages/Auth/OAuth/oAuthActionTypes";

export const getOAuthToken = ({ code, redirectUri }) => {
	return dispatch => {
		return new Promise((resolve, reject) => {
			axios
				.post(
					`/oauth`,
					{
						redirectUri: redirectUri,
						code: code,
					},
					{
						baseURL: env("OAUTH_API_URL"),
						headers: {
							"Content-type": "text/plain",
						},
					}
				)
				.then(res => {
					const token = res.data.token;

					dispatch(oAuthSuccess(token));

					resolve(token);
				})
				.catch(error => {
					dispatch(clearOAuthorizationCode());
					reject(error);
				});
		});
	};
};

export const oAuthSuccess = token => {
	const shop = getStore().getState().shop;

	try {
		Cookies.set("authToken", token, {
			expires: COOKIES_AUTH_EXPIRES,
			path: `/${shop}`,
		});
		Cookies.set("auth", "auth", { expires: COOKIES_OAUTH_EXPIRES, path: `/${shop}` });
	} catch (e) {
		// TODO
		console.error("cookies set", e); // eslint-disable-line no-console
	}
	return {
		type: OAUTH_SUCCESS,
		token,
	};
};

export const saveOAuthorizationCode = code => {
	return {
		type: SAVE_OAUTHORIZATION_CODE,
		code,
	};
};

export const clearOAuthorizationCode = code => {
	return {
		type: CLEAR_OAUTHORIZATION_CODE,
		code,
	};
};
